import { createIconSet } from '@expo/vector-icons';
import glyphMap from '~/../assets/fonts/Ionicons/unicodesMap.json';
export default createIconSet(glyphMap, 'Ionicons', require('~/../assets/fonts/Ionicons/Ionicons.ttf'));
